import { createSlice, PayloadAction } from '@reduxjs/toolkit'


interface UserMenuState {
  menu: any[]; // ✅ 建议明确类型
  currentmenu: any[]; // ✅ 建议明确类型
  childernmenu: any[]; // ✅ 建议明确类型
}

const initialState: UserMenuState = {
  menu: [],   // ✅ 接口返回的原始路由
  currentmenu: [],//当前渲染的路由
  childernmenu: [],//所有三级路由（控制的是页面上的功能——上传、查看、导出等
}

const userMenuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setUserMenu: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      // 如果传的是数组，就直接用
      const menu = Array.isArray(payload?.menu) ? payload.menu : Array.isArray(payload) ? payload : [];

      // 返回新 state，完全安全
      return {
        ...state,
        menu,
      };
    },
    setCurrentMenu: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      // 如果传的是数组，就直接用
      const menu = Array.isArray(payload?.currentmenu) ? payload.currentmenu : Array.isArray(payload) ? payload : [];

      // 返回新 state，完全安全
      return {
        ...state,
        currentmenu: menu,
      };
    },
    setChildrenMenu: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      // 如果传的是数组，就直接用
      const menu = Array.isArray(payload?.childernmenu) ? payload.childernmenu : Array.isArray(payload) ? payload : [];

      // 返回新 state，完全安全
      return {
        ...state,
        childernmenu: menu,
      };
    },
    // 统一清空菜单相关状态（用于退出登录 / 进入登录页时重置）
    clearMenu: (state) => {
      state.menu = []
      state.currentmenu = []
      state.childernmenu = []
    },
  },
})

export const { setUserMenu, setCurrentMenu, setChildrenMenu, clearMenu } = userMenuSlice.actions
export default userMenuSlice.reducer
